module.exports = __webpack_public_path__ + "static/img/companyIcon.6c6edb84.svg";